import { VuexModule, Module } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class ReportModule extends VuexModule {}
